// Le côté Radar du bouton « Connecter » de l'extension (issue #139). Le
// protocole et ses raisons sont dans `@ai-job-fit/engine/pontExtension`.
//
// Monté par `App` sur TOUT écran d'un compte Radar connecté, inscription
// comprise : l'extension ouvre l'aide, mais un compte neuf est retenu sur
// l'inscription, et un pont qui ne répondrait que depuis l'aide ferait
// attendre le bouton dix minutes sans rien dire.
//
// Le code n'est demandé qu'une fois par montage : le relais redemande chaque
// seconde tant qu'il n'a rien reçu, et chaque appel fabriquerait un nouveau
// code qui annule le précédent.

import { useEffect } from 'react'
import { lireMessagePont, PONT_CODE, PONT_DEMANDE, PONT_RESULTAT } from '@ai-job-fit/engine/pontExtension'
import { post } from '../lib/api'
import { useT } from '../lib/i18n'
import { useToast } from './common'

export function PontExtension() {
  const t = useT()
  const toast = useToast()
  useEffect(() => {
    let code: Promise<{ code: string }> | null = null
    const surMessage = (e: MessageEvent) => {
      if (e.source !== window || e.origin !== window.location.origin) return
      const m = lireMessagePont(e.data)
      if (m?.type === PONT_DEMANDE) {
        code ??= post<{ code: string }>('/api/auth/extension/code', {})
        code.then(
          (c) => window.postMessage({ type: PONT_CODE, code: c.code }, window.location.origin),
          // Un échec se retente à la demande suivante, une seconde plus tard.
          () => { code = null }
        )
      } else if (m?.type === PONT_RESULTAT) {
        if (m.ok) toast(t('aide.pont.ok'))
        else toast(t('aide.pont.echec'), 'err')
      }
    }
    window.addEventListener('message', surMessage)
    return () => window.removeEventListener('message', surMessage)
  }, [t, toast])
  return null
}
